import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minuteSeconds'
})
export class MinutesSecondPipe implements PipeTransform{
    transform(value: number): string {
        const minutes: number = Math.floor(value / 60);
        return minutes.toString().padStart(2, '0') + ' minutes ' + Math.floor((value - minutes * 60)).toString().padStart(2, '0');
    }


}




// WEBPACK FOOTER //
// ./src/app/common/pipes/seconds-minutes.pipe.ts